import React, { useMemo } from 'react';
import {
  ResponsiveContainer,
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
} from 'recharts';
import moment from 'moment';

const EvolutionChart = ({ aggregatedData, lines }) => {
//  const aggregatedData = useMemo(() => {
//    const groups = {};
//    aggregatedData.forEach((item) => {
//      const monthKey = moment(item.date, "YYYY-MM").format('MM/YYYY');
//      if (!groups[monthKey]) {
//        groups[monthKey] = { month: monthKey, Disparos: 0, MarketStories: 0, Tyra: 0 };
//      }
//      groups[monthKey][item.type] += item.total;
//    });
//    const dataArray = Object.values(groups);
//    dataArray.sort((a, b) => moment(a.month, 'MM/YYYY') - moment(b.month, 'MM/YYYY'));
//    return dataArray;
//  }, [aggregatedData]);

  return (
    <ResponsiveContainer width="100%" height={500}>
        <LineChart
          data={aggregatedData}
          margin={{ top: 0, right: 0, bottom: 0, left: 20 }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="date" />
          <YAxis
            width={70}
            tickMargin={10}
            tickFormatter={(value) => `R$ ${value?.toLocaleString('pt-BR')}`}
          />
          <Tooltip formatter={(value) => `R$ ${value?.toLocaleString('pt-BR')}`} />
          <Legend />
          {lines.map(v => (
            <Line type="linear" dataKey={v.dataKey} name={v.name} stroke={v.stroke} strokeWidth={3} activeDot={{ r: 8 }} />
          ))}
        </LineChart>
      </ResponsiveContainer>
  );
};

export default EvolutionChart;
